/** Shared layout tokens for delivery option rows + delete column alignment. */
export const DELETE_COLUMN_WIDTH = "20px";

export const OPTION_ROW_OUTER_GAP = 2;

type DeliveryOptionCardState = {
  isSelected: boolean;
  isInteractionDisabled: boolean;
  isReadOnly?: boolean;
};

export function getDeliveryOptionCardStyles({
  isSelected,
  isInteractionDisabled,
  isReadOnly,
}: DeliveryOptionCardState) {
  if (isReadOnly) {
    return {
      p: 3,
      borderRadius: "md" as const,
      bg: isSelected ? "blue.50" : "white",
      border: "1px solid",
      borderColor: isSelected ? "blue.400" : "gray.200",
      cursor: "default",
      opacity: isSelected ? 1 : 0.6,
      transition: "all 0.2s",
      _hover: {
        borderColor: isSelected ? "blue.400" : "gray.200",
        bg: isSelected ? "blue.50" : "white",
        transform: "none",
        shadow: "none",
      },
    };
  }
  return {
    p: 3,
    borderRadius: "md" as const,
    bg: isSelected ? "blue.50" : "white",
    border: "1px solid",
    borderColor: isSelected ? "blue.400" : "gray.200",
    cursor: isInteractionDisabled ? "not-allowed" : "pointer",
    opacity: isInteractionDisabled ? 0.6 : 1,
    transition: "all 0.2s",
    _hover: {
      borderColor: isInteractionDisabled ? "gray.200" : "blue.300",
      bg: isInteractionDisabled
        ? "white"
        : isSelected
          ? "blue.50"
          : "gray.50",
      transform: isInteractionDisabled ? "none" : "translateY(-1px)",
      shadow: isInteractionDisabled ? "none" : "sm",
    },
  };
}
